// Dati del titolare del trattamento: compilare prima della pubblicazione.
// I valori vuoti vengono mostrati come segnaposto evidenti, mai inventati.
export const LEGAL = {
  ragioneSociale: "Luca Sarnelli",
  partitaIva: "18057791008",
  sede: "Via dei Pini 11, 00055 Ladispoli (RM)",
  email: (process.env.REACT_APP_CONTACT_EMAIL || "").trim(),
  siteUrl: (process.env.REACT_APP_SITE_URL || "").trim(),
  ultimoAggiornamento: "2026-10-04",
  conservazioneMesi: 24,
};

export const LEGAL_NOTE = "Testo base da far verificare dal proprio consulente legale prima della pubblicazione.";

export const ph = (value, label) => (value && value.trim() ? value : `[${label} da inserire]`);
